<template>
  <div>
    <v-toolbar>
      <div class="search-box">
        <v-text-field
          single-line
          solo
          light
          clearable
          class="search-field"
          append-icon="search"
          placeholder="Tìm kiếm theo User, Biển số xe"
          color="warning"
          v-model="searchText"
          v-on:keyup.enter="search()"
          @click:append="search()"
          :loading="loading"
          :disabled="loading"
        ></v-text-field>
      </div>
      <v-btn icon large @click="clearUncheck">
        <v-icon>clear_all</v-icon>
      </v-btn>
    </v-toolbar>
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-layout row>
        <v-flex xs12>
          <v-card v-for="(item, index) in datasource" :key="index">
            <v-list>
              <v-list-tile color="primary">
                <v-list-tile-action v-show="checkSelected(item)">
                  <v-btn flat icon color="primary" dark @click="REMOVE_COMPANIES(item)">
                    <v-icon>check_box</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-content @click="setSelectedCompanies(item)">
                  <v-list-tile-title>{{item.Name}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <div v-if="item.MatchUsers.length > 0">
                <v-list-tile
                  @click="setSelectedCompanies(item)"
                  v-for="user in item.MatchUsers"
                  :key="user.Id"
                >
                  <v-list-tile-action></v-list-tile-action>

                  <v-list-tile-content
                    @contextmenu.prevent="openContextMenu($event, item, user, null)"
                  >
                    <v-list-tile-title>{{user.Username}}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon>person_outline</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </div>

              <v-divider inset v-if="item.MatchUsers.length > 0 && item.MatchVehicles.length > 0"></v-divider>

              <div v-if="item.MatchVehicles.length > 0">
                <v-list-tile
                  @click="setSelectedCompanies(item)"
                  v-for="vehicle in item.MatchVehicles"
                  :key="vehicle.Id"
                >
                  <v-list-tile-action></v-list-tile-action>

                  <v-list-tile-content
                    @contextmenu.prevent="openContextMenu($event, item, null, vehicle)"
                    :class="getVehicleClass(vehicle)"
                  >
                    <v-list-tile-title>{{vehicle.Plate}}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon>directions_car</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </div>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </vue-perfect-scrollbar>

    <!-- Context Menu -->
    <vue-context ref="contextMenu" :style="{ width: '300px' }">
      <v-list>
        <v-list-tile @click="getUsersByVehicle()">
          <v-list-tile-title>
            <v-icon class="menu-item-icon">people</v-icon>
            <span>Get Users</span>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="goToWebApp()">
          <v-list-tile-title>
            <v-icon class="menu-item-icon">public</v-icon>
            <span>Go to quanlyxe.vn</span>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile :href="supportUrl" target="_blank">
          <v-list-tile-title>
            <v-icon class="menu-item-icon">laptop_mac</v-icon>
            <span>Go to vmsupport.quanlyxe.vn</span>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile :href="billingUrl" target="_blank">
          <v-list-tile-title>
            <v-icon class="menu-item-icon">laptop_mac</v-icon>
            <span>Go to billing.apps.vietmap.vn</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </vue-context>
    <!-- Context Menu -->

    <!-- Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="isShowDialog" width="480">
        <v-card>
          <v-card-title class="headline">User list</v-card-title>
          <v-card-text>
            <!-- <p v-for="(item, index) in usersByVehicle" :key="index">{{item.Username}}</p> -->
            <v-list>
              <v-list-tile v-for="(item, index) in usersByVehicle" :key="index" avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.Username"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn icon color="transparent" @click="goToWebAppBySelectUser(item)">
                    <v-icon color="primary">input</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="isShowDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- End Dialog -->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { VueContext } from 'vue-context';
import validate from '@/utils/validate';

export default {
  components: { VuePerfectScrollbar, VueContext },
  data () {
    return {
      scrollSettings: {
        maxScrollbarLength: 160
      },
      datasource: [],
      searchText: '',
      loading: false,

      selectedCompany: null,
      selectedUser: null,
      selectedVehicle: null,
      usersByVehicle: [],
      isShowDialog: false
    };
  },
  computed: {
    ...mapGetters(['searchResults', 'selectedCompanies']),
    supportUrl() {
      return `https://vmsupport.quanlyxe.vn/monitor?vehicleId=${this.selectedVehicle ? this.selectedVehicle.Id : ''}`;
    },
    billingUrl() {
      return `https://billing.apps.vietmap.vn/#/account/${this.selectedCompany ? this.selectedCompany.Id : ''}`;
    }
  },
  watch: {
    searchResults () {
      this.datasource = this.searchResults;
    }
  },
  created () {
    if (this.searchResults) {
      this.datasource = this.searchResults;
    }
  },
  methods: {
    ...mapActions([
      'SeachCompanyRequest',
      'GetUserLoginKeyRequest',
      'GetUsersByVehicleRequest'
    ]),
    ...mapMutations(['SET_COMPANIES', 'REMOVE_COMPANIES', 'SET_SEARCH_TEXT']),

    search () {
      if (this.searchText) {
        let keywordRemovedVietnamese = this.searchText;

        this.SET_SEARCH_TEXT(this.searchText);
        this.loading = true;

        let key = keywordRemovedVietnamese;
        if (keywordRemovedVietnamese.startsWith('/') || keywordRemovedVietnamese.startsWith('"')) {
          key = keywordRemovedVietnamese.replace('/', '');
          key = keywordRemovedVietnamese.replace('"', '');
        } else {
          key = validate.transferVietnamese(this.searchText);
        }

        this.SeachCompanyRequest({ Key: key })
          .catch(error => {
            console.log(error);
            window.getApp.showMessage(
              'Có lỗi xảy ra, vui lòng thử lại sau',
              'error'
            );
          })
          .finally(_ => {
            this.loading = false;
          });
      }
    },

    clearUncheck () {
      let ids = this.selectedCompanies.map(a => a.Id);
      this.datasource = this.datasource.filter(a => ids.includes(a.Id));
    },

    getVehicleClass (v) {
      if (v.Inactive) {
        return 'inactive-vehicle';
      }
      if (v.IsLocked) {
        return 'locked-vehicle';
      }
    },

    setSelectedCompanies (item) {
      this.SET_COMPANIES(item);
    },

    checkSelected (item) {
      return this.selectedCompanies.includes(item);
    },

    openContextMenu (event, company, user, vehicle) {
      this.$refs.contextMenu.open(event);
      this.selectedCompany = company;
      this.selectedUser = user;
      this.selectedVehicle = vehicle;
    },

    getUsersByVehicle () {
      if (this.selectedVehicle && this.selectedVehicle.Id) {
        window.getApp.showLoading(true);
        this.GetUsersByVehicleRequest({ Id: this.selectedVehicle.Id })
          .then(res => {
            this.usersByVehicle = res;
            if (res.length > 0) {
              this.isShowDialog = true;
            } else {
              window.getApp.showMessage('Không có dữ liệu', 'error');
            }
          })
          .catch(_ => {
            window.getApp.showMessage(
              'Có lỗi xảy ra, vui lòng thử lại sau',
              'error'
            );
          })
          .finally(_ => {
            window.getApp.showLoading(false);
          });
      }
    },

    goToWebAppBySelectUser (user) {
      this.selectedUser = user;
      this.goToWebApp();
    },

    goToWebApp () {
      if (this.selectedUser) {
        this.goToWebAppByUser();
      } else if (!this.selectedUser && this.selectedVehicle) {
        this.goToWebAppByVehicle();
      }
    },

    goToWebAppByUser () {
      if (this.selectedUser && this.selectedUser.Id) {
        window.getApp.showLoading(true);
        this.GetUserLoginKeyRequest({ Id: this.selectedUser.Id })
          .then(key => {
            window.open(
              `https://quanlyxe.vn/Account.aspx/ForceLogin/${this.selectedUser.Id}?key=${key}`
            );
          })
          .catch(_ => {
            window.getApp.showMessage(
              'Có lỗi xảy ra, vui lòng thử lại sau',
              'error'
            );
          })
          .finally(_ => {
            window.getApp.showLoading(false);
          });
      }
    },

    goToWebAppByVehicle () {
      if (this.selectedVehicle.Id) {
        this.GetUsersByVehicleRequest({ Id: this.selectedVehicle.Id })
          .then(res => {
            if (res.length > 0) {
              this.selectedUser = res[0];
              this.goToWebAppByUser();
            } else {
              window.getApp.showMessage(
                'Không tìm được User quản lý xe này',
                'error'
              );
            }
          })
          .catch(_ => {
            window.getApp.showMessage(
              'Có lỗi xảy ra, vui lòng thử lại sau',
              'error'
            );
          });
      }
    }
  }
};
</script>

<style scoped>
.drawer-menu--scroll {
  height: calc(100vh - 66px - 64px);
  overflow: auto;
}
.v-card {
  box-shadow: 0 1px 1px 0 rgba(60, 64, 67, 0), 0 1px 3px 1px #00000000 !important;
  border-bottom: 1px solid #e0e0e0 !important;
}
p {
  margin-left: 10px;
}
.v-list__tile__content {
  cursor: pointer !important;
}
</style>

<style>
.v-list__tile {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 15px;
  font-weight: 400;
  height: 36px !important;
  margin: 0;
  padding: 0 16px;
  position: relative;
  text-decoration: none;
  -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.menu-item-icon {
  font-size: 15pt;
  padding-right: 12px;
}

.inactive-vehicle {
  text-decoration: line-through !important;
}

.locked-vehicle {
  color: orange !important;
}

.search-box {
  margin-top: 8px !important;
  width: 90% !important;
}
.v-toolbar__content,
.v-toolbar__extension {
  padding: 0 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/components/Results.vue